import API from "./index";

class HistoricoSenadoService {
  constructor() {
    this.path = `/api/historicosenado`;
  }

  findByIdItemBemPermanente(id) {
    return API.get(`${this.path}/findByIdItemBemPermanente/${id}`);
  }

}

export default HistoricoSenadoService;
